export default "__VITE_ASSET__BVq5AU8Q__"